var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 11C18.5 12.7354 17.2845 15.0151 15.4992 17.042C14.6469 18.0096 13.7557 18.814 13.0013 19.3586C12.6228 19.6318 12.3118 19.8157 12.0844 19.9232C12.0526 19.9383 12.0245 19.9508 12 19.9613C11.9755 19.9508 11.9474 19.9383 11.9156 19.9232C11.6882 19.8157 11.3772 19.6318 10.9987 19.3586C10.2443 18.814 9.35307 18.0096 8.50081 17.042C6.71547 15.0151 5.5 12.7354 5.5 11C5.5 6.98063 8.28138 4 12 4C15.7186 4 18.5 6.98063 18.5 11ZM20.5 11C20.5 15.9706 14 22 12 22C10 22 3.5 15.9706 3.5 11C3.5 6.02944 7.02944 2 12 2C16.9706 2 20.5 6.02944 20.5 11ZM13.5 10.5C13.5 11.3284 12.8284 12 12 12C11.1716 12 10.5 11.3284 10.5 10.5C10.5 9.67157 11.1716 9 12 9C12.8284 9 13.5 9.67157 13.5 10.5ZM15.5 10.5C15.5 12.433 13.933 14 12 14C10.067 14 8.5 12.433 8.5 10.5C8.5 8.567 10.067 7 12 7C13.933 7 15.5 8.567 15.5 10.5Z",
    fill: "#484E68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bc9daa1d7f1526db1dae7b1db5ca7087.svg";
export { ForwardRef as ReactComponent };